function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import math from 'polished/lib/math/math';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
import typography from '../utils/typography';
import { useTheme } from '@veneer/theme';
var useStyles = _ref => {
  var {
    responsiveBreakpoint
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => {
    return {
      container: _objectSpread(_objectSpread({
        display: 'flex',
        flex: 1,
        flexDirection: 'row'
      }, highContrastMediaQuery(theme)), {}, {
        ["@media (max-width: ".concat(responsiveBreakpoint, ")")]: {
          alignItems: 'center',
          flexDirection: 'column'
        }
      }),
      paginationContainer: {
        display: 'flex',
        flex: 2 / 3,
        justifyContent: 'flex-end'
      },
      pageSizeSelect: {
        '&': _objectSpread(_objectSpread({
          alignItems: 'center',
          color: theme.palette.foreground.medium,
          display: 'flex',
          flex: 1 / 3
        }, typography(theme).label), {}, {
          height: theme.layout.size8,
          justifyContent: 'flex-start',
          '> span': {
            paddingLeft: theme.orbitalTwo
          },
          '> button': _objectSpread(_objectSpread({
            padding: "".concat(theme.orbitalOne, " ").concat(theme.orbitalTwo),
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'transparent',
            borderColor: theme.palette.neutral.default,
            borderStyle: 'solid',
            borderWidth: '1px',
            borderRadius: theme.borderRadius3,
            color: theme.palette.foreground.medium,
            cursor: 'pointer'
          }, typography(theme).label), {}, {
            transition: 'background-color 150ms ease-in, border-color 150ms ease-in',
            userSelect: 'none',
            '> svg': {
              color: 'inherit',
              height: theme.typography.size2,
              padding: 0,
              paddingLeft: theme.orbitalOne,
              width: theme.typography.size2
            },
            '&:disabled': {
              borderColor: theme.palette.foreground.disabled,
              color: theme.palette.foreground.disabled,
              cursor: 'auto'
            },
            '&:hover': {
              backgroundColor: theme.palette.neutral.backgroundLight,
              borderColor: theme.palette.neutral.hover
            },
            '&[data-focused="true"]': _objectSpread({
              borderWidth: '2px',
              backgroundColor: theme.palette.background.container,
              borderColor: theme.palette.primary.default,
              padding: "calc(".concat(theme.orbitalOne, " - 1px) calc(").concat(theme.orbitalTwo, " - 1px)")
            }, theme.mode === 'contrast' && {
              borderColor: theme.palette.primary.active
            }),
            '&:active': {
              borderWidth: '2px',
              backgroundColor: theme.palette.neutral.background,
              borderColor: theme.palette.neutral.active,
              padding: "calc(".concat(theme.orbitalOne, " - 1px) calc(").concat(theme.orbitalTwo, " - 1px)")
            }
          })
        }),
        ["@media (max-width: ".concat(responsiveBreakpoint, ")")]: {
          marginBottom: theme.layout.size2
        }
      },
      navigation: _objectSpread({
        ul: {
          alignItems: 'center',
          display: 'flex',
          flexFlow: 'row wrap',
          margin: 0,
          padding: 0,
          '> li': {
            display: 'inline-flex',
            padding: "0 calc(".concat(theme.layout.size1, "/2)"),
            '> *': _objectSpread({
              alignItems: 'center',
              boxSizing: 'border-box',
              display: 'inline-flex',
              height: theme.layout.size8,
              justifyContent: 'center',
              margin: 0,
              minWidth: theme.layout.size8,
              padding: 0,
              textDecoration: 'none'
            }, typography(theme).label),
            '> .ellipsis': {
              color: theme.palette.foreground.default
            },
            '> button:not(:disabled, .next, .previous)': _objectSpread(_objectSpread({
              backgroundColor: 'transparent',
              border: 0,
              padding: "0 ".concat(math("".concat(theme.layout.size2, " - 2px"))),
              borderRadius: theme.borderRadius3,
              color: theme.palette.foreground.default
            }, typography(theme).label), {}, {
              cursor: 'pointer',
              transition: 'background-color 150ms ease-in',
              '&.previous, &.next': {
                padding: 0
              },
              '@media (hover: hover)': {
                '&:hover, &[data-focused="true"]': {
                  backgroundColor: theme.palette.neutral.backgroundLight
                }
              },
              '&:active': {
                backgroundColor: theme.palette.neutral.background
              },
              '&[aria-current="true"]': {
                backgroundColor: theme.palette.primary.default,
                color: theme.palette.foreground.inverse,
                '@media (hover: hover)': {
                  '&:hover, &[data-focused="true"]': {
                    backgroundColor: theme.palette.primary.hover
                  }
                },
                '&:active': {
                  backgroundColor: theme.palette.primary.active
                }
              }
            }, theme.mode === 'contrast' && {
              color: theme.palette.primary.default,
              '@media (hover: hover)': {
                '&:hover, &[data-focused="true"]': {
                  backgroundColor: theme.palette.primary.hover,
                  color: theme.palette.foreground.inverse
                }
              },
              '&:active': {
                backgroundColor: theme.palette.primary.active,
                color: theme.palette.foreground.inverse
              }
            })
          }
        }
      }, highContrastMediaQuery(theme))
    };
  }, [responsiveBreakpoint, theme]);
};
export default useStyles;